import { api } from 'api'
import { User } from 'typings/common_defs'

export interface WorkerProfileShift {
  id: number
  startsAt: string
  endsAt: string
  location: {
    name: string
    address: {
      timezone: string
    }
  }
  position: {
    name: string
  }
}

export type Worker = Pick<
  User,
  | 'id'
  | 'name'
  | 'profilePicUrl'
  | 'backgroundCheckStatus'
  | 'firstActive'
  | 'favorites'
  | 'numPaidShifts'
  | 'numFinishedShifts'
  | 'numShiftsForCompany'
  | 'numHoursForCompany'
  | 'numHoursForCompanyPastWeek'
  | 'rating'
  | 'shadowBlocked'
  | 'status'
  | 'statusForCompany'
  | 'positionTemplateBlocks'
  | 'workProfile'
  | 'rosters'
  | 'address'
>

type WorkerStatusForCompanyRequest = {
  action: 'block' | 'favorite' | 'unblock' | 'unfavorite'
  reason?: string
}

export async function updateWorkerStatusForCompany(
  companyId: number,
  workerId: number,
  data: WorkerStatusForCompanyRequest
) {
  return api.post<void>(`/company/${companyId}/action`, {
    worker_id: workerId,
    action: data.action,
    reason: data.reason,
  })
}
